// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"33f482b1","415":"4614d26d","551":"7f19635f","661":"ec57a90d","674":"297801a2","721":"81c34cff"}[chunkId] + ".chunk.css";
};